<template>
    <div>
        <Header title="龙虎榜单"></Header>
        <div class="tabs">
            <div v-for="(tab, k) in tabs" :key="k" class="tab" @click="currentTab=k">
                <span class="tab-text" :class="{'selected': currentTab == k}">{{ tab }}</span>
            </div>
        </div>
        <keep-alive>
            <component :is="tabComponent[currentTab]"></component>
        </keep-alive>
    </div>
</template>

<script>
import DragonTigerList from './list/dragon-tiger';
import SalesList from './list/sales';
import Header from './header.vue';
import SafariAdapter from './mixin/safari-adapter-mixin';
export default {
    mixins: [SafariAdapter],
    components: {
        Header
    },
    data() {
        return {
            tabs: ['今日龙虎榜', '营业部榜'],
            currentTab: 0,
            tabComponent: [DragonTigerList, SalesList],
        }
    },
}
</script>

<style lang="stylus" scoped>
.tabs
    position relative
    z-index 2
    display flex
    height .34rem
    box-sizing border-box
    background rgba(255,255,255,1)
    border-bottom .01rem solid rgba(237,239,243,1)
    .tab
        width 50%
        height 100%
        text-align center
        font-size .15rem
        font-family PingFangSC-Regular,PingFang SC
        font-weight 400
        color rgba(51,51,51,1)
        box-sizing border-box
        padding .02rem 0
        .tab-text
            height 100%
            display inline-block
            padding 0 .02rem
            line-height .3rem
        .selected
            color rgba(244,55,55,1)
            border-bottom 2px solid rgba(244,55,55,1)
            font-family PingFangSC-Medium,PingFang SC
            font-weight 500
</style>